import {
  rcoCrossBorderShipmentSegmentSchema,
  RcoSegmentStep,
} from "@redotech/redo-model/advanced-flow/advanced-flow-db-parser";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const CrossBorderShipmentInspectorContent = memo(
  function CrossBorderShipmentInspectorContent({
    step,
  }: {
    step: RcoSegmentStep;
  }) {
    rcoCrossBorderShipmentSegmentSchema.parse(step.segment);

    return (
      <Flex align="flex-start" dir="column" gap="xs">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          Condition
        </Text>
        <Text fontSize="xs" fontWeight="medium" textColor="primary">
          Origin country differs from destination country
        </Text>
      </Flex>
    );
  },
);

export const EditableCrossBorderShipmentInspectorContent = memo(
  function EditableCrossBorderShipmentInspectorContent({
    step,
  }: {
    step: Omit<RcoSegmentStep, "matchingNextId" | "nonMatchingNextId"> & {
      matchingNextId?: string | undefined;
      nonMatchingNextId?: string | undefined;
    };
  }) {
    rcoCrossBorderShipmentSegmentSchema.parse(step.segment);

    return (
      <Flex align="flex-start" dir="column" gap="xs">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          Condition
        </Text>
        <Text fontSize="xs" fontWeight="medium" textColor="primary">
          Origin country differs from destination country
        </Text>
      </Flex>
    );
  },
);
